import type { z } from 'zod'

import { parseResponse } from '~/utils/parseResponse'

/** Builds an endpoint operation: prepare resolves the URL and request options, the success schema parses the response, project shapes the result. A response that fails the success schema throws ResponseParseError. */
export const createRequestOperation =
  <Arguments extends readonly unknown[], SuccessSchema extends z.ZodType, Result, Options>(
    client: (url: string, options: Options) => Promise<unknown>,
    successSchema: SuccessSchema,
    prepare: (...args: Arguments) => { readonly url: string; readonly options: Options },
    project: (success: z.output<SuccessSchema>) => Result
  ): ((...args: Arguments) => Promise<Result>) =>
  async (...args: Arguments): Promise<Result> => {
    const { url, options } = prepare(...args)
    return project(parseResponse(successSchema, await client(url, options), url))
  }
